import {
  Reward,
  Score,
  PetRewards,
  PetScores,
  PGoldBalance,
  PGoldPrice,
  FpPrice,
} from "../../../common/types";
import { PGoldBalanceChart } from "../charts/PGoldBalanceChart";
import { RewardChart } from "../charts/RewardChart";
import { ScoreChart } from "../charts/ScoreChart";
import { useState } from "react";

function ToggleButton({ value, isDarkMode }: { value: boolean; isDarkMode: boolean }) {
  return (
    <div
      className={`flex h-4 w-7 flex-row items-center rounded-full border-2 ${
        isDarkMode ? "border-darkgreen bg-darkblue" : "border-brown bg-white"
      } ${value ? "justify-end" : "justify-start"}`}
    >
      <div className={`m-1 h-2 w-2 rounded-full ${isDarkMode ? "bg-darkgreen" : "bg-brown"}`}></div>
    </div>
  );
}

export function Charts({
  rewards,
  scores,
  petRewards,
  petScores,
  pGoldBalance,
  pGoldPrices,
  fpPrices,
  isDarkMode,
}: {
  rewards: Reward[];
  scores: Score[];
  petRewards: PetRewards;
  petScores: PetScores;
  pGoldBalance: PGoldBalance[];
  pGoldPrices: PGoldPrice[];
  fpPrices: FpPrice[];
  isDarkMode: boolean;
}) {
  const [showPets, setHideTotal] = useState(false);

  return (
    <div className={`flex w-full flex-col items-center justify-center`}>
      <div
        className="flex cursor-default items-center justify-center"
        onClick={() => setHideTotal(!showPets)}
      >
        <p className={`mr-2 font-sans text-sm ${isDarkMode ? "text-white" : "text-brown"}`}>
          Show Pets
        </p>{" "}
        <ToggleButton isDarkMode={isDarkMode} value={showPets} />
      </div>
      <RewardChart
        isDarkMode={isDarkMode}
        rewards={rewards}
        petRewards={petRewards}
        showPets={showPets}
      />
      <ScoreChart
        isDarkMode={isDarkMode}
        scores={scores}
        petScores={petScores}
        showPets={showPets}
      />
      <PGoldBalanceChart
        isDarkMode={isDarkMode}
        pGoldBalances={pGoldBalance}
        pGoldPrices={pGoldPrices}
        fpPrices={fpPrices}
      />
    </div>
  );
}
